const DAY = 86400000;

export const utcNoon = (iso) => {
  const d = new Date(iso);
  return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 12));
};

export const addMonths = (date, m) => {
  const y = date.getUTCFullYear();
  const mo = date.getUTCMonth() + m;
  const last = new Date(Date.UTC(y, mo + 1, 0)).getUTCDate();
  return new Date(Date.UTC(y, mo, Math.min(date.getUTCDate(), last), 12));
};

export const addDays = (date, n) => new Date(date.getTime() + n * DAY);

export const fmtDay = (d) => d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", timeZone: "UTC" });
export const fmtLong = (d) => d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" });

export function monthPlan(submittedAt) {
  const start = utcNoon(submittedAt);
  return [1, 2, 3].map((m) => {
    const from = addMonths(start, m - 1);
    const to = addDays(addMonths(start, m), -1);
    const days = [];
    for (let d = from; d <= to; d = addDays(d, 1)) {
      days.push({ date: d, week: Math.min(13, Math.floor((d - start) / (7 * DAY)) + 1), dayIndex: Math.round((d - start) / DAY) });
    }
    return { month: m, from, to, days };
  });
}

export const nextAssessment = (submittedAt) => addMonths(utcNoon(submittedAt), 3);
